export default `
mutation createShift(
  $divisionId: ID!,
  $shiftId: ID!, 
  $createdBy: ID!, 
  $userId: ID,
  $note: String, 
  $startTime: Float!, 
  $endTime: Float!, 
  $requiredLevels: [OfficerLevel],
  $serviceProviderId: ID!,
  $timezone: String!,
  $postOrders: [PostOrderInput!]!
) {
  createShift(
    divisionId: $divisionId,
    shiftId: $shiftId, 
    createdBy: $createdBy, 
    userId: $userId,
    note: $note, 
    startTime: $startTime, 
    endTime: $endTime, 
    requiredLevels: $requiredLevels,
    serviceProviderId: $serviceProviderId,
    timezone: $timezone,
    postOrders: $postOrders
  ) {
    createdAt
    updatedAt
    publishedAt
    acknowledgedAt
    updatedBy
    shiftId
    status
    createdBy
    userId
    isDeleted
    note
    startTime
    endTime
    serviceProviderId
    requests
    divisionId
    requiredLevels
    timezone
    postOrders {
      description
      time {
        start
        end
      }
      propertyId
      dar {
        isRequired
        darId
      }
      completed {
        timestamp
        coordinates {
          lat
          lng
        }
      }
    }
  }
}
`;